/**
 * @packageDocumentation
 * @module Checks
 */
var defaultMessage = 'Assertion failed';
/**
 * Assert that a condition is true, or throw an error
 *
 * @param {boolean} condition
 * @param {?string} message
 *
 * @throws {Error}
 */
export var assert = function (condition, message) {
    var result = condition instanceof Function ? condition() : condition;
    if (!result) {
        throw new Error(message || defaultMessage);
    }
};
//# sourceMappingURL=assert.js.map